'use client';
import React from 'react';
import { Mail, MessageSquare, HelpCircle, School } from 'lucide-react';

const CONTACT_TOPICS = [
  {
    icon: School,
    title: 'School Listings',
    description: "Questions about a school's profile, data accuracy, or missing information.",
  },
  {
    icon: HelpCircle,
    title: 'General Enquiries',description: 'Anything else — partnerships, feedback, or how SchoolMapper works.',
  },
  {
    icon: MessageSquare,
    title: 'Technical Support',description: 'Issues with the website, search, or your account.',
  },
];

export default function ContactClient() {
  return (
    <main className="max-w-3xl mx-auto px-3 sm:px-6 lg:px-8 py-6 sm:py-12">
      {/* Page heading */}
      <div className="mb-6 sm:mb-10">
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-foreground tracking-tight">Contact Us</h1>
        <p className="mt-2 text-muted-foreground text-sm sm:text-base">
          Have a question or want to get in touch? We&apos;d love to hear from you.
        </p>
      </div>
      {/* Primary contact card */}
      <div className="rounded-2xl border border-border bg-white shadow-sm p-5 sm:p-8 mb-5 sm:mb-8 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
        <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-primary/10 flex items-center justify-center">
          <Mail size={22} className="text-primary" />
        </div>
        <div>
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide mb-1">Email us at</p>
          <a
            href="mailto:info@schoolmapper.ae"
            className="text-xl sm:text-2xl font-display font-semibold text-primary hover:underline break-all"
          >
            info@schoolmapper.ae
          </a>
          <p className="mt-1.5 text-sm text-muted-foreground">
            We aim to respond to all enquiries within 1–2 business days.
          </p>
        </div>
      </div>
      {/* Topic cards */}
      <div className="grid gap-3 sm:gap-4 grid-cols-1 sm:grid-cols-3">
        {CONTACT_TOPICS?.map((topic) => (
          <div
            key={topic?.title}
            className="rounded-xl border border-border bg-white p-4 sm:p-5 hover:shadow-sm transition-shadow"
          >
            <div className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center mb-3">
              <topic.icon size={18} className="text-foreground/70" />
            </div>
            <h3 className="font-display font-semibold text-sm text-foreground mb-1">{topic?.title}</h3>
            <p className="text-xs text-muted-foreground leading-relaxed">{topic?.description}</p>
          </div>
        ))}
      </div>
      {/* Footer note */}
      <p className="mt-8 sm:mt-10 text-center text-xs text-muted-foreground">
        SchoolMapper is operated from Dubai, UAE.{' '}
        <a href="mailto:info@schoolmapper.ae" className="text-primary hover:underline">
          info@schoolmapper.ae
        </a>
      </p>
    </main>
  );
}
